// Angular
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { KeyValue } from '@angular/common';
// models
import { DropdownOption } from 'src/app/models';
// samplings
import { EditSampleDTO, EditSampleError, SamplingDetail } from '../../../modules/samples-member/models';

@Component({
    selector: 'app-sample-edit-detail',
    templateUrl: './sample-edit-detail.component.html',
    styleUrls: ['./sample-edit-detail.component.scss'],
    standalone: false
})
export class SampleEditDetailComponent {
    @Input() buyersOptions: DropdownOption<number>[] = [];
    @Input() editMode: boolean = true;
    @Input() errorMessage: string = null;
    @Input() isRMO: boolean = false;
    @Input() loading: boolean = false;
    @Input() provinceOptions: DropdownOption<number>[] = [];
    @Input() sample: SamplingDetail;
    @Input() sampleDataError: EditSampleError;
    @Input() sampleDataForm: EditSampleDTO;
    @Input() warehouseOptions: DropdownOption<number>[] = [];

    @Output() formChange: EventEmitter<KeyValue<string, string | number>> = new EventEmitter<
        KeyValue<string, string | number>
    >();
    @Output() saveSampleData: EventEmitter<void> = new EventEmitter<void>();
    @Output() dismiss: EventEmitter<void> = new EventEmitter<void>();

    onFormChange(key: string, value: string | number) {
        setTimeout(() => {
            this.formChange.emit({ key: key, value: value });
        }, 0);
    }

    onSaveSampleData() {
        this.saveSampleData.emit();
    }

    onDismiss(): void {
        this.dismiss.emit();
    }
}
